import { render, staticRenderFns } from "./ListViewSkeleton.vue?vue&type=template&id=9270b36a&scoped=true"
import script from "./ListViewSkeleton.vue?vue&type=script&lang=js"
export * from "./ListViewSkeleton.vue?vue&type=script&lang=js"
import style0 from "./ListViewSkeleton.vue?vue&type=style&index=0&id=9270b36a&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "9270b36a",
  null
  
)

export default component.exports